
import { defineComponent } from "vue";
import { usePanelStore } from "@/stores/panelStore";
import RemoteRenderView from "./remoteRenderView.vue";
import { useWslinkStore } from "@/stores/ssaStore/wslink";
import { useLayoutStore } from "@/stores/layoutStore";
import { usePvwStore } from "@/stores/ssaStore/pvw";
import { storeToRefs } from "pinia";
import { usePickingStore } from "@/stores/ssaStore/picking";
import { useActiveStore } from "@/stores/ssaStore/active";
import { useLayerStore } from "@/stores/ssaStore/layer";
import { useSsaStore } from "@/stores/ssaStore";
import { useViewStore } from "@/stores/ssaStore/views";
import { useBusyStore } from "@/stores/ssaStore/busy";
import { useDisplayPaneStore } from "@/stores/ssaStore/displayPane";
import { useHierarchyStore } from "@/stores/hierarchyStore";
import { split } from "lodash";

const SEL_RADIUS = 4;

export default defineComponent({
	name: "imdex-3D-view",
	components: {
		RemoteRenderView
	},
	setup() {
		const ssaStore = useSsaStore();
		const layer = storeToRefs(useLayerStore());
		const panelStore = usePanelStore();
		const wsLink = useWslinkStore();
		const layoutStore = useLayoutStore();
		const active = useActiveStore();
		const pvw = usePvwStore();
		const viewStore = useViewStore();
		const pickStore = usePickingStore();
		const { SSA_SHOW_PICK_DATA: showPickData } = storeToRefs(usePickingStore());
		const { view: activeView, SSA_ACTIVE_LAYER: activeLayer } = storeToRefs(useActiveStore());
		const { SSA_PICK_DATA: pickData } = storeToRefs(usePickingStore());
		const { PVW_PICK_POLYGON: pickPolygon, PVW_CLEAR_PICK_SELECTION: clearPickSelection } =
			usePvwStore();
		//const{  SSA_PICK_SELECTION_ENABLED: enableSelection} = usePickingStore();
		const { isDragging } = storeToRefs(layoutStore);
		const { BUSY_IS: isBusy } = storeToRefs(useBusyStore());
		const { visualizers, activeVisualizer } = storeToRefs(panelStore);
		const { displayStates } = storeToRefs(useDisplayPaneStore());
		const { hierarchyStates } = storeToRefs(useHierarchyStore());
		return {
			hierarchyStates,
			displayStates,
			clearPickSelection,
			pickPolygon,
			showPickData,
			activeView,
			activeLayer,
			pickData,
			isBusy,
			ssaStore,
			layer,
			active,
			pickStore,
			pvw,
			panelStore,
			wsLink,
			activeVisualizer,
			visualizers,
			isDragging,
			viewStore
		};
	},
	props: {
		componentState: {
			type: Object,
			default: () => {
				return { flex: 1, color: "#fff" };
			}
		},
		id: {
			type: Number,
			default: -1
		}
	},

	data() {
		return {
			name: this.$t("ssa.visualizer.3dView.visualizer"),
			drillhole: require("@/assets/svg/hole_type2.svg"),
			blockmodel: require("@/assets/svg/bm_type.svg"),
			shape: require("@/assets/svg/polygon_type.svg"),
			//
			north: require("@/assets/svg/north.svg"),
			east: require("@/assets/svg/east.svg"),
			south: require("@/assets/svg/south.svg"),
			west: require("@/assets/svg/west.svg"),
			top: require("@/assets/svg/top.svg"),
			bottom: require("@/assets/svg/bottom.svg"),
			//
			rotate: require("@/assets/svg/rotate.svg"),
			select_center: require("@/assets/svg/select-center.svg"),
			unlock: require("@/assets/svg/unlock.svg"),
			lock: require("@/assets/svg/lock.svg"),
			split_h: require("@/assets/svg/split-h.svg"),
			split_v: require("@/assets/svg/split-v.svg"),
			export: require("@/assets/svg/export.svg"),
			grid: require("@/assets/svg/grid.svg"),
			cube: require("@/assets/svg/cube.svg"),
			up_down: require("@/assets/svg/up-down.svg"),
			//
			isOver: true,
			zType: "solid",
			showVis: false,
			collapsed: false,
			cantSplit: false,
			cantSplitH: false,
			enableSelection: true,
			enableCameraCenter: false,
			overlayOn: false,
			pickStart: null as any,
			polyPoints: null as any,
			localLightMode: false,
			//PICKING
			keyListener: null as any,
			isPicking: false,
			splitHMenu: false,
			splitVMenu: false
		};
	},
	beforeUnmount() {
		window.removeEventListener("mousemove", this.keyListener);
		// document.removeEventListener("keydown", this.keypressForOverlay);
		// document.removeEventListener("keyup", this.keypressForOverlay);
	},
	mounted() {
		if (this.$refs.renderer) {
			const { width, height } = (this.$refs.renderer as any).getBoundingClientRect();
			(this.$refs.overlay as any).width = width;
			(this.$refs.overlay as any).height = height;
		}
		this.keyListener = (e: any) => {
			if (!this.isPicking && e.shiftKey) {
				if (
					this.active?.SSA_SELECTED_DATASETS?.[this.active?.SSA_ACTIVE_DATASET?.id] &&
					this.activeLayer &&
					this.activeLayer.includes(this.active.SSA_ACTIVE_DATASET.id)
				) {
					this.isPicking = true;
					this.pickStore.SHOW_PICK_DATA(true);
					this.pickStore.SSA_PICK_MODE_SET("point");
					if (
						this.active.SSA_ACTIVE_REPRESENTATION_STATE &&
						this.active.SSA_ACTIVE_REPRESENTATION_STATE.geometry.Opacity &&
						this.active.SSA_ACTIVE_REPRESENTATION_STATE.geometry.Opacity == 1
					) {
						this.ssaStore.SSA_REPRESENTATION_UPDATE_PROPERTY({
							viewId: this.activeView,
							layerName: this.activeLayer,
							type: "geometry",
							name: "Opacity",
							value: 0.99
						});
					}
				} else {
					this.pickStore.SHOW_PICK_DATA(false);
				}
			}
			if (this.isPicking && !e.shiftKey) {
				this.isPicking = false;
				this.pickStore.SSA_PICK_MODE_SET("NO_PICKING");
				if (
					this.active.SSA_ACTIVE_REPRESENTATION_STATE &&
					this.active.SSA_ACTIVE_REPRESENTATION_STATE.geometry.Opacity &&
					this.active.SSA_ACTIVE_REPRESENTATION_STATE.geometry.Opacity == 0.99
				) {
					this.ssaStore.SSA_REPRESENTATION_UPDATE_PROPERTY({
						viewId: this.activeView,
						layerName: this.activeLayer,
						type: "geometry",
						name: "Opacity",
						value: 1
					});
				}
			}
		};

		// document.addEventListener("keydown", this.keypressForOverlay);
		// document.addEventListener("keyup", this.keypressForOverlay);

		window.addEventListener("mousemove", this.keyListener);

		const resize_ob = new ResizeObserver((entries) => {
			// since we are observing only a single element, so we access the first element in entries array
			const rect = entries[0].contentRect;

			if (this.$refs.renderer) {
				const { width, height } = (this.$refs.renderer as any).getBoundingClientRect();
				(this.$refs.overlay as any).width = width;
				(this.$refs.overlay as any).height = height;
			}

			// current width & height
			const width = rect.width;
			const height = rect.height;

			if (width < 250) {
				this.collapsed = true;
			} else {
				this.collapsed = false;
			}
			if (width < 500) {
				this.cantSplit = true;
			} else {
				this.cantSplit = false;
			}
			if (height < 500) {
				this.cantSplitH = true;
			} else {
				this.cantSplitH = false;
			}
		});
		resize_ob.observe((this.$refs as any)[`v-container`]);
	},
	methods: {
		splitH(clone: boolean) {
			this.panelStore.SPLIT_PANEL({ type: "h", panel1: this.id, clone });
			this.splitHMenu = false;
		},
		splitV(clone: boolean) {
			this.panelStore.SPLIT_PANEL({ type: "v", panel1: this.id, clone });
			this.splitVMenu = false;
		},
		keypressForOverlay(event: any) {
			// if (this.enableSelection) {
			// Prevent browser from stealing focus to the menu bar.
			if (event.shiftKey) return;
			if (this.overlayOn && !event.altKey) event.preventDefault();
			this.doOverlay(event.altKey, "keypress");
			// clear any current selection on 'Esc' key
			// clear any in-progress select, too.
			if (event.key === "Escape") {
				this.clearPickSelection({
					viewId: this.activeView,
					layerName: this.activeLayer
				});
				this.clearOverlay();
				this.pickStart = null;
				this.polyPoints = null;
			}
			// }
		},
		changeZ(z: any) {
			const n = Number(z.target.value);
			this.zScaling = n;
		},
		incrementZ(v: number) {
			if (v === -1) {
				if (this.zScaling <= 1) this.zScaling = 0.1;
				else this.zScaling = Math.round(this.zScaling + v);
			} else if (v === 1) {
				this.zScaling = Math.round(Math.min(this.zScaling + v, 10));
			}
		},
		toggleBackground() {
			this.localLightMode = !this.localLightMode;
			this.ssaStore.SSA_TOGGLE_ACTIVE_VIEW_BACKGROUND();
		},
		pickingListener(e: any) {
			// e is generated by paraviewweb server - not a browser MouseEvent.
			// e.action, altKey, buttonLeft, buttonMiddle, buttonRight, ctrlKey, metaKey, shiftKey
			if (e.action === "up") {
				e.viz = this.pickStore.SSA_PICK_POINT_ENABLED;
				this.pickStore.SSA_PICK_EVENT_SET(e);
				this.pickStore.SSA_PICK_UPDATE();
			}
		},
		mouseForOverlay(event: any) {
			if (this.enableSelection && this.overlayOn) {
				this.doOverlay(event.altKey, "mouse");
			}
		},
		getMousePos(event: any) {
			const container: any = this.$refs.overlay;
			const bounds = container.getBoundingClientRect();
			const pixX = event.clientX - bounds.left;
			const pixY = event.clientY - bounds.top;
			const pos = {
				// normalized, 0 -> 1, with y == 0 at the bottom
				x: pixX / bounds.width,
				y: (bounds.height - pixY) / bounds.height,
				// window/canvas pixel coords, y == 0 at the top
				pixX,
				pixY
			};
			return pos;
		},
		handleClick(event: any): any {
			this.doOverlay(event.altKey, "click");
			// If we're in pick a camera center-of-rotation mode, finish the pick.
			if (this.enableCameraCenter) {
				// get the center out of the last picked data world coords.
				if (this.pickStore.SSA_PICK_DATA && this.pickStore.SSA_PICK_DATA.worldPosition) {
					const center = this.pickStore.SSA_PICK_DATA.worldPosition;
					this.pvw.PVW_SET_CAMERA_CENTER({ viewId: this.active.view, center });
					// Reset mode only when valid point picker
					this.pickStore.SSA_PICK_DISABLE();
				}
				// send an extra pick event to turn off the rendered pick position.
				this.pickStore.SSA_PICK_EVENT_SET(
					Object.assign({}, this.pickStore.SSA_PICK_EVENT, { viz: false })
				);
				this.pickStore.SSA_PICK_UPDATE();
			}
		},
		doOverlay(toggle: any, where?: any): any {
			if (!this.enableSelection) {
				this.overlayOn = false;
			}
			// if alt key is down, or if we've already started a pick, keep overlay on.
			else if (toggle || this.pickStart) {
				this.overlayOn = true;
				this.pickStore.SSA_PICK_MODE_SET("selectPoly");
			} else {
				this.overlayOn = false;
				this.pickStore.SSA_PICK_MODE_SET("NO PICKING");
			}
			return where;
		},
		overlayPickDown(event: any) {
			// overlay must be active for box/poly selection to start.
			if (this.enableSelection && !this.pickStart && event.altKey) {
				// transform to normalized, like RenderWindowInteractor, getScreenEventPositionFor
				this.pickStart = this.getMousePos(event);
				(this.pickStart as any).mode = event.ctrlKey
					? "add"
					: event.shiftKey
					? "subtract"
					: "replace";
				(this.pickStart as any).fullHole = this.pickStore.SSA_PICK_HOLE;
			}
		},
		overlayPickMove(event: any) {
			if (!this.$refs.overlay || !this.pickStart) return;

			const canvas: any = this.$refs.overlay;
			const { width, height } = canvas.getBoundingClientRect();

			const ctx = canvas.getContext("2d");
			ctx.clearRect(0, 0, width, height);

			const pos = this.getMousePos(event);
			ctx.strokeStyle = "#FF22FF";
			ctx.fillStyle = "#FF22FF";
			if (this.pickStore.SSA_PICK_MODE === "selectBox") {
				const rect = [
					Math.min(this.pickStart.x, pos.x) * width,
					(1.0 - Math.max(this.pickStart.y, pos.y)) * height,
					Math.abs(this.pickStart.x - pos.x) * width,
					Math.abs(this.pickStart.y - pos.y) * height
				];
				ctx.strokeRect(...rect);
			} else if (this.pickStore.SSA_PICK_MODE === "selectPoly") {
				if (!this.polyPoints) {
					this.polyPoints = [this.pickStart];
				}
				// show a circle as a target for closing the polygon
				ctx.beginPath();
				ctx.arc(this.polyPoints[0].pixX, this.polyPoints[0].pixY, SEL_RADIUS, 0, 360);
				ctx.fill();

				// show closed polygon as the user moves.
				ctx.beginPath();
				ctx.moveTo(this.polyPoints[0].pixX, this.polyPoints[0].pixY);
				for (let i = 0; i < this.polyPoints.length; ++i) {
					ctx.lineTo(this.polyPoints[i].pixX, this.polyPoints[i].pixY);
				}
				// draw rubber-band to current mouse and back to start.
				ctx.lineTo(pos.pixX, pos.pixY);
				ctx.lineTo(this.polyPoints[0].pixX, this.polyPoints[0].pixY);
				ctx.stroke();
			}
		},
		overlayPickUp(event: any) {
			if (this.enableSelection && this.pickStart) {
				const pos = this.getMousePos(event);
				if (this.pickStore.SSA_PICK_MODE === "selectBox") {
					this.pickStore.PVW_PICK_AREA({
						// this.pickPolygon({
						viewId: this.activeView,
						area: [this.pickStart.x, this.pickStart.y, pos.x, pos.y],
						// points: [this.pickStart.x, this.pickStart.y,
						//   pos.x, this.pickStart.y,
						//   pos.x, pos.y,
						//   this.pickStart.x, pos.y,
						//   ],
						layerName: this.activeLayer,
						mode: this.pickStart.mode,
						fullHole: this.pickStart.fullHole
					});
					this.clearOverlay();
					this.polyPoints = null;
					this.pickStart = null;
				} else if (this.pickStore.SSA_PICK_MODE === "selectPoly") {
					const ps = this.pickStart;
					if (!this.polyPoints) {
						this.polyPoints = [this.pickStart];
					} else if (
						(ps.pixX - pos.pixX) * (ps.pixX - pos.pixX) +
							(ps.pixY - pos.pixY) * (ps.pixY - pos.pixY) <
						SEL_RADIUS * SEL_RADIUS
					) {
						if (this.polyPoints.length === 1) {
							// user clicked and released at start point - don't add another.
						} else {
							// user finished the polygon - do select.
							// this.finishPickPoly();
						}
					} else {
						this.polyPoints.push(pos);
					}
				}
			}
		},
		overlayDblClick(event: any) {
			event.preventDefault();
			this.finishPickPoly();
		},
		finishPickPoly() {
			// TODO
			const xyList: any = [];
			this.polyPoints.forEach((pt: any) => {
				xyList.push(pt.x, pt.y);
			});
			this.pickPolygon({
				viewId: this.activeView,
				points: xyList,
				layerName: this.activeLayer,
				mode: this.pickStart.mode,
				fullHole: this.pickStart.fullHole
			});

			this.polyPoints = null;
			this.pickStart = null;
			this.clearOverlay();
		},
		clearOverlay() {
			const canvas: any = this.$refs.overlay;
			const { width, height } = canvas.getBoundingClientRect();
			const ctx = canvas.getContext("2d");
			ctx.clearRect(0, 0, width, height);
		}
	},
	computed: {
		canClone() {
			const displayKeys = Object.keys(this.displayStates);
			if (this.hierarchyStates != null) {
				if (this.hierarchyStates[this.activeView] != null) {
					if (this.hierarchyStates[this.activeView].selected.length > 0) {
						return displayKeys.indexOf(this.activeView) > -1 && true;
					}
				}
			}
			return false;
		},
		pickDetails() {
			if (
				this.active.dataset[this.activeView] &&
				this.pickData &&
				this.active.dataset[this.activeView].datasetColumnMapping
			) {
				const displayOrderMap = {} as any;

				this.active.dataset[this.activeView].datasetColumnMapping.forEach((item: any) => {
					if (this.activeLayer && this.activeLayer.includes(item.layerIdentifier)) {
						displayOrderMap[item.column] = item.displayOrder;
					}
				});

				const map = this.active.dataset[this.activeView].datasetColumnMapping.map(
					(item: any) => {
						return {
							label: item.label,
							prop: item.column
						};
					}
				);

				const columns = map.map((item: any) => item.prop);
				const data = [];

				this.pickStore.SSA_PICK_DATA_STORE_PUSH({
					id: this.pickData.vtkOriginalPointIds
				});

				const sortedPickDataKeys = Object.keys(this.pickData).sort((a, b) => {
					const aOrder = displayOrderMap[a] ?? 9999; // Default is 9999;
					const bOrder = displayOrderMap[b] ?? 9999; // Default is 9999;

					return aOrder > bOrder ? 1 : bOrder > aOrder ? -1 : 0;
				});

				for (let i = 0; i < sortedPickDataKeys.length; i++) {
					if (columns.includes(sortedPickDataKeys[i])) {
						this.pickStore.SSA_PICK_DATA_STORE_PUSH({
							["id"]: this.pickData.vtkOriginalPointIds,
							[map[
								map.findIndex((item2: any) => {
									return item2.prop == sortedPickDataKeys[i];
								})
							] &&
							map[
								map.findIndex((item2: any) => {
									return item2.prop == sortedPickDataKeys[i];
								})
							].label]: this.pickData[sortedPickDataKeys[i]]
						});
						data.push(
							`<div class="detail-label">${
								map[
									map.findIndex((item2: any) => {
										return item2.prop == sortedPickDataKeys[i];
									})
								] &&
								map[
									map.findIndex((item2: any) => {
										return item2.prop == sortedPickDataKeys[i];
									})
								].label
							}:<span> ${this.pickData[sortedPickDataKeys[i]]}</span></div>`
						);
					}
				}
				let innerHtml = data.join("");
				if (data.length == 0) {
					innerHtml = this.$t("ssa.visualizer.3dView.noData");
				}

				return innerHtml;
			} else {
				return this.$t("ssa.visualizer.3dView.noDataBase");
			}
			// if(this.displayStates[this.activeView] && this.displayStates[this.activeView][this.active.dataset[this.activeView].id]){
			// 	const map = this.displayStates[this.activeView][this.active.dataset[this.activeView].id].configuration.availableProperties.children.map((item)=>item.name)
			// }
			// return 'No Details'
		},

		gridOn() {
			return (
				this.viewStore.SSA_VIEW_STATES &&
				this.viewStore.SSA_VIEW_STATES[this.componentState.viewId] &&
				this.viewStore.SSA_VIEW_STATES[this.componentState.viewId].gridVisibility
			);
		},
		perspectiveOn() {
			return (
				this.viewStore.SSA_VIEW_STATES &&
				this.viewStore.SSA_VIEW_STATES[this.componentState.viewId] &&
				this.viewStore.SSA_VIEW_STATES[this.componentState.viewId].cameraParallelProjection
			);
		},
		light() {
			return (
				this.viewStore.SSA_VIEW_STATES &&
				this.viewStore.SSA_VIEW_STATES[this.componentState.viewId] &&
				this.viewStore.SSA_VIEW_STATES[this.componentState.viewId].foreground[0] != 0.91
			);
		},
		zScaling: {
			get(): any {
				return (
					(this.viewStore.SSA_VIEW_STATES[this.componentState.viewId] &&
						this.viewStore.SSA_VIEW_STATES[this.componentState.viewId].zScaling) ||
					1.0
				);
			},
			set(v: any) {
				v = Number(v);
				if (v < 0.5) {
					v = 0.1;
				} else {
					v = Math.round(Math.min(v, 10));
				}
				if (v != null) {
					this.ssaStore.SSA_UPDATE_ACTIVE_VIEW_STATE({ zScaling: v });
				}
			}
		},
		isLinked() {
			return (
				this.viewStore.SSA_VIEW_STATES &&
				this.viewStore.SSA_VIEW_STATES[this.componentState.viewId] &&
				this.viewStore.SSA_VIEW_STATES[this.componentState.viewId].linked
			);
		},
		enablePicking() {
			return this.overlayOn || this.isPicking;
		},
		activeViewId() {
			return 1;
		},
		dataType() {
			return "drillhole";
		},
		bottomButtons() {
			return [
				{
					icon: "grid",
					name: this.$t("ssa.visualizer.3dView.showGrid"),
					action: () => {
						this.ssaStore.SSA_TOGGLE_ACTIVE_AXES_GRID();
					}
				},
				{
					icon: "cube",
					name: this.$t("ssa.visualizer.3dView.togglePerspective"),
					action: () => {
						this.ssaStore.SSA_TOGGLE_ACTIVE_VIEW_PROJECTION_MODE();
					}
				}
				// {
				// 	icon: "up_down",
				// 	name: "Z Scaling Factor",
				// 	action: () => {
				// 		console.log("up-down");
				// 	}
				// }
			];
		},
		panelButtons() {
			return [
				// {
				//     icon:'export',
				//     name:'Export',
				//     action:()=>{console.log('export')}
				// },
				// {
				// 	icon: "split_h",
				// 	disabled: this.cantSplitH || this.visualizers.length == 4,
				// 	name: "Split Horizontally",
				// 	action: () => {
				// 		this.panelStore.SPLIT_PANEL({ type: "h", panel1: this.id });
				// 	}
				// },
				// {
				// 	icon: "split_v",
				// 	disabled: this.cantSplit || this.visualizers.length == 4,
				// 	name: "Split Vertically",
				// 	action: () => {
				// 		this.panelStore.SPLIT_PANEL({ type: "v", panel1: this.id });
				// 	}
				// }
				// { THIS IS FOR THE DATA TABLE BUTTONS
				// 	icon: "split_v",
				// 	disabled: this.cantSplit || this.visualizers.length == 4,
				// 	name: "Create Data Table Vertically",
				// 	action: () => {
				// 		this.panelStore.SPLIT_PANEL({ type: "datav", panel1: this.id });
				// 	}
				// },
				// {
				// 	icon: "split_h",
				// 	disabled: this.cantSplit || this.visualizers.length == 4,
				// 	name: "Create Data Table Horizontally",
				// 	action: () => {
				// 		this.panelStore.SPLIT_PANEL({ type: "datah", panel1: this.id });
				// 	}
				// }
			];
		},
		contentButtons() {
			return [
				{
					icon: "top",
					name: this.$t("ssa.visualizer.3dView.viewFromTop"),
					action: () => {
						this.pvw.PVW_SET_VIEW_UP({
							viewId: this.componentState.viewId,
							viewType: "z+",
							northpole: false
						});
						this.pickStore.SHOW_PICK_DATA(false);
					}
				},
				{
					icon: "bottom",
					name: this.$t("ssa.visualizer.3dView.viewFromBottom"),
					action: () => {
						this.pvw.PVW_SET_VIEW_UP({
							viewId: this.componentState.viewId,
							viewType: "z-",
							northpole: false
						});
						this.pickStore.SHOW_PICK_DATA(false);
					}
				},
				{
					icon: "north",
					name: this.$t("ssa.visualizer.3dView.lookNorth"),
					action: () => {
						this.pvw.PVW_SET_VIEW_UP({
							viewId: this.componentState.viewId,
							viewType: "y-",
							northpole: false
						});
						this.pickStore.SHOW_PICK_DATA(false);
					}
				},
				{
					icon: "east",
					name: this.$t("ssa.visualizer.3dView.lookEast"),
					action: () => {
						this.pvw.PVW_SET_VIEW_UP({
							viewId: this.componentState.viewId,
							viewType: "x-",
							northpole: false
						});
						this.pickStore.SHOW_PICK_DATA(false);
					}
				},
				{
					icon: "south",
					name: this.$t("ssa.visualizer.3dView.lookSouth"),
					action: () => {
						this.pvw.PVW_SET_VIEW_UP({
							viewId: this.componentState.viewId,
							viewType: "y+",
							northpole: false
						});
						this.pickStore.SHOW_PICK_DATA(false);
					}
				},
				{
					icon: "west",
					name: this.$t("ssa.visualizer.3dView.lookWest"),
					action: () => {
						this.pvw.PVW_SET_VIEW_UP({
							viewId: this.componentState.viewId,
							viewType: "x+",
							northpole: false
						});
						this.pickStore.SHOW_PICK_DATA(false);
					}
				},
				{
					icon: "select_center",
					name: this.$t("ssa.visualizer.3dView.selectCenterRot"),
					action: () => {
						if (this.pickStore.SSA_PICK_MODE == "cameraCenter") {
							this.pickStore.SSA_PICK_MODE_SET("NO_PICKING");
							this.overlayOn = false;
							this.enableCameraCenter = false;
							this.ssaStore.SSA_UPDATE_ACTIVE_VIEW_STATE({
								centerAxesVisibility: false
							});
						} else {
							this.pickStore.SSA_PICK_MODE_SET("cameraCenter");
							this.overlayOn = true;
							this.enableCameraCenter = true;
							this.ssaStore.SSA_UPDATE_ACTIVE_VIEW_STATE({
								centerAxesVisibility: true
							});
						}
						this.pickStore.SHOW_PICK_DATA(false);
					}
				},
				{
					icon: "rotate",
					name: this.$t("ssa.visualizer.3dView.resetZoom"),
					action: () => {
						this.pvw.PVW_RESET_CAMERA({ viewId: this.componentState.viewId });
						this.pickStore.SHOW_PICK_DATA(false);
					}
				},
				{
					icon: this.isLinked ? "lock" : "unlock",
					name: this.$t("ssa.visualizer.3dView.lockUnlock"),
					action: () => {
						this.pvw.PVW_VIEW_LINK({
							viewId: this.componentState.viewId,
							link: !this.isLinked
						});
						this.pickStore.SHOW_PICK_DATA(false);
					}
				}
			];
		}
	},
	watch: {
		activeLayer(curr: string, prev: string) {
			if (this.showPickData && curr != prev) {
				this.pickStore.SSA_PICK_DISABLE();
				this.pickStore.SSA_PICK_EVENT_SET(
					Object.assign({}, this.pickStore.SSA_PICK_EVENT, { viz: false })
				);
				this.pickStore.SSA_PICK_UPDATE();
			}
		}
	}
});
